<mat-list>
	<mat-list-item lines="none">
		<p>Lower bound: {{ rangeValues.lower }} Mb</p>
		<br />
		<p>Upper bound: {{ rangeValues.upper }} Mb</p>
	</mat-list-item>
	<mat-list-item lines="none">
		<mat-slider
			dualKnobs="true"
			min="0"
			max="1000"
			step="10"
			pin="true"
			[(ngModel)]="rangeValues">
		</mat-slider>
	</mat-list-item>
</mat-list>
